var React = require('react');

function SmartphoneInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"14.71","y":"10.71","width":"2.93","height":"2.93","key":0}),React.createElement("rect",{"x":"14.71","y":"15.93","width":"2.93","height":"2.93","key":1}),React.createElement("path",{"d":"M29.5,34.23H9.97V6.05H29.5v28.18Zm-16.83-2.7h14.13V8.75H12.67V31.53Z","key":2})]);
}

SmartphoneInline.defaultProps = {"width":"32","height":"32","id":"Warstwa_1","viewBox":"0 0 40 40"};

module.exports = SmartphoneInline;

SmartphoneInline.default = SmartphoneInline;
